<template>
    <div style="height: 100%;width: 100%">

        <div style="height: 90%;width: 100%">
          <span style="font-weight: bold">选择支付方式</span>
          <DxRadioGroup
              :items="payMethods"
              :value="payMethods[0]"
              layout="horizontal"
          />

          <span style="font-weight: bold">选择套餐扫码充值</span>
          <div class="meal-container">
            <div class="meal-block" v-for="(item, index) in mealInfo" :key="index" @click="handleSelect(item)" :style="{ 'borderColor': item.borderColor }">
              <p style="font-weight: bold">{{ item.mealName }}</p>
              <p>￥<span style="color: #ff5722;font-size: 21px">{{ item.currentPrice / 100 }}</span>/{{ item.point }} 积分</p>
              <p v-if="item.limitBuyCount !== -1" style="color: #ff5722">限购{{item.limitBuyCount}}次</p>
              <p v-else style="color: #ff5722">不限购买次数</p>
            </div>
          </div>

          <div>
            <span style="color: #ff5722;font-size: 17px">积分消费说明：A=1积分，B=4积分，C=15积分</span>
          </div>
          <div>
            <span style="color: #ff5722;font-size: 17px">关于分值说明：</span>
          </div>
          <div>
            <span style="color: #ff5722;font-size: 17px">A是对接查查的接口，B是全网采集的接口，C是定制方式的接口</span>
          </div>
        </div>

        <div align="center" style="height: 10%;width: 100%">
          <DxButton @click="redirectInfo" text="充值" type="success" class="validate" style="margin-right: 10px" />
          <DxButton  type="danger" :use-submit-behavior="true" @click="$emit('close')" text="关闭"/>
        </div>

        <DxPopup :visible="popupVisibleCode" :show-title="true" :drag-enabled="false" title="请使用微信扫码支付" :width="400" :height="400">
            <div id="qrcode" ref="qrcode" align="center"></div>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after"  :options="closeButtonOptions"></DxToolbarItem>
        </DxPopup>

    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';

    export default {
      components:{
        // eslint-disable-next-line vue/no-unused-components
        QRCode,
      },
        name: "RechargeMain",
        data() {
            return {
                od:{
                    mealId: null,
                },
                popupVisibleCode:false,
                closeButtonOptions: {
                    text: 'Close',
                    stylingMode: "contained",
                    onClick: () => {
                        this.popupVisible = false;
                        this.popupVisibleCode = false;
                        this.popupVisibleImport = false;
                      document.getElementById('qrcode').innerHTML = '';
                    },
                },
                text:null,
                selectedPointInfo: null,
                mealInfo: [],
                payMethods: [{id:1, text: '微信支付'}]
            };
        },
        created() {
          this.getPointMeal()
        },
        methods:{
          getPointMeal(){
            this.$http.getPointMealAllList().then(res => {
              let data = res.data
              this.mealInfo = data.map(item => {
                item.borderColor = '#f7f7f7'
                return item
              })
            })
          },
          handleSelect(item) {
            const mealId = item.mealId
            this.od.mealId = mealId
            this.mealInfo = this.mealInfo.map(meal => {
              if(meal.mealId === mealId) {
                meal.borderColor = '#ff5722'
              } else {
                meal.borderColor = '#f7f7f7'
              }
              return meal
            })
          },
          redirectInfo(e){
            if(this.od.mealId == null) {
              this.$message({type: 'error', message: '请选择套餐', center: true});
              return
            }

            //查找二维码
            this.$http.wxPay(this.od).then(res=>{
                if(res.status == "success"){
                    this.popupVisibleCode = true
                    setTimeout(() => {
                        new QRCode('qrcode',{
                            width: 200,
                            height: 200,
                            text: res.data.code_url
                        })
                    }, 100)
                    this.$emit("renew")
                }else {
                  this.$message({type: 'error', message: res.msg, center: true});
                }

            })
          },
          changeSelection(e){
              this.od.amount=e.value.substring(0, e.value.length - 1)-0;
          },
          changeSelectionType(e){
              this.selectedMealType=e.value;
          },
        },

    }
</script>

<style scoped>
  .meal-container {
    display: flex;
    gap: 40px;
    padding: 10px;
  }

  .meal-block{
    flex: 1;
    width: 100px;
    height: 100%;
    border-width: 2px;
    border-style: solid;
    border-radius: 5%;
    text-align: center;
  }

</style>
